module.exports = __webpack_public_path__ + "img/atendimento-diabetes.e240b6e5.svg";